"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flow = void 0;
var flow_component_1 = require("./flow-component");
var invocation_1 = require("./invocation");
var Flow = /** @class */ (function () {
    function Flow(data) {
        var _this = this;
        this.id = null;
        this.status = null;
        this.operations = {};
        this.id = data.id;
        this.status = data.status || null;
        this.error = data.error || null;
        this.invocation = new invocation_1.Invocation(data.invocation);
        Object.keys(data.operations).map(function (key) {
            _this.operations[key] = new flow_component_1.FlowComponent(data.operations[key]);
        });
    }
    return Flow;
}());
exports.Flow = Flow;
//# sourceMappingURL=flow.js.map